import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    '& .label' : {
      color: '#69738c',
      fontWeight: 'bold'
    }
  },
  premise: {
    "& > .label": {
      marginBottom: 20
    }
  },
  answer: {
    marginTop: 25,
    flexGrow: 1,
    color: '#828dab',
    "& .choice": {
      display: 'flex',
      marginTop: 20, 
      padding: '10px 15px',
      flexGrow: 1,
      borderRadius: 4,
      background: '#edf6fd',
      flexDirection: 'column',
      "& .header" : {
        display: 'flex',
        "& .sorter": {
          fontSize: '14pt',
          cursor: 'pointer'
        },
        "& .filler": {
          flexGrow: 1
        },
        "& .delete": {
          fontSize: '14pt',
          cursor: 'pointer',
          color: '#ff3a3a',
          '&:hover': {
            transform: 'scale(1.1)'
          }
        }
      },
      "& .index" : {
        color: '#6a748d',
        margin: '15px 5px 8px 0',
        fontWeight: 'bold'
      },
      "& .correct": {
        marginTop: 9 
      }
    }
  }
}))

export {useStyles as default}
